<template>
  <MyJump v-if="jump" :to="jump" :msg="$t('page.reg.register_ok')"/>
  <div v-else class="page-register">
    <div class="title">{{$t('page.reg.title')}}</div>
    <Form ref="formRegister" :model="formInfo" :rules="ruleValidate" :label-width="120">
      <FormItem :label="$t('page.login.state_code')" prop="state_code">
        <SCodeSelect v-model="formInfo.state_code" prepared
                     :placeholder="$t('page.login.ph_statecode')"/>
      </FormItem>
      <FormItem :label="$t('page.login.mobile')" prop="mobile">
        <Input v-model="formInfo.mobile" maxlength="20" ref="mobile"
               prefix="ios-phone-portrait"
               :placeholder="$t('page.login.ph_mobile')"/>
      </FormItem>
      <FormItem :label="$t('page.reg.pwd')" prop="password">
        <Input v-model="formInfo.password" maxlength="15" ref="pwd"
               :type="type?'password':'text'"
               prefix="ios-key"
               :placeholder="$t('page.reg.ph_pwd')">
          <Icon  :type="type?'ios-eye':'ios-eye-off'" class="btn-eye" slot="suffix" @click="onShowPwd()" size="20"/>
        </Input>
      </FormItem>
      <FormItem :label="$t('page.reg.pwd_confirm')" prop="password1">
        <Input v-model="formInfo.password1" maxlength="15"
               :type="type?'password':'text'"
               prefix="ios-key"
               :placeholder="$t('page.reg.ph_pwd_confirm')">
          <Icon :type="type?'ios-eye':'ios-eye-off'" class="btn-eye" slot="suffix" @click="onShowPwd()" size="20"/>
        </Input>
      </FormItem>
      <FormItem :label="$t('page.reg.mobile_code')" prop="code">
        <div style="display: flex;">
        <Input v-model="formInfo.code" maxlength="6" ref="el_sms"
               prefix="ios-code-working" style="width: 150px">
        </Input>
        <Button @click.stop="onObtainSms" class="dark-btn"
                :disabled="busy||(smsDelay>0)">{{$t('page.reg.btn_code')}}{{smsInfo}}</Button>
        </div>

      </FormItem>
    </Form>

<!--    <div style="margin-bottom: 10px; margin-top:20vh;">-->
<!--      <p style="margin-bottom: 10px;">{{$t('page.reg.tip_reg')}}</p>-->
<!--      <Button @click="register" type="error"-->
<!--              :loading="logining"-->
<!--              class="long-btn"-->
<!--              style="margin-bottom: 10px;">{{$t('page.reg.btn_reg')}}</Button>-->
<!--      <br>-->
<!--      <Button @click="toLogin" type="default"-->
<!--              class="long-btn"-->
<!--              style="margin-bottom: 10px;">{{$t('page.reg.btn_login')}}</Button>-->
<!--    </div>-->
    <div>
      <div :style="{height:footerButtonHeight+'px'}"></div>
      <div ref="bottomButtons" class="bottom-buttons bottom-buttons-fixed">
        <div>
          <Checkbox v-model="agree_privacy">{{$t('page.reg.label_agree')}}
            <!--<router-link to="privacy">{{$t('page.reg.label_privacy')}}</router-link>-->
          </Checkbox>
          <a @click.stop="show_privacy=true">{{$t('page.reg.label_privacy')}}</a>
        </div>
        <p style="margin-bottom: 10px;">{{$t('page.reg.tip_reg')}}</p>
        <Button @click="register"
                :loading="logining"
                class="btn btn-ok"
                style="margin-bottom: 10px;">{{$t('page.reg.btn_reg')}}</Button>
        <Button @click="toLogin"
                class="btn"
                style="margin-bottom: 10px;">{{$t('page.reg.btn_login')}}</Button>
      </div>
    </div>

    <!-- 隐私条款 -->
    <Modal v-model="show_privacy"
           @on-ok="agree_privacy=true" @on-cancel="agree_privacy=false"
           :ok-text="$t('page.reg.btn_agree')" :cancel-text="$t('page.reg.btn_disagree')"
           fullscreen :closable="false" :mask-closable="false">
      <Privacy/>
    </Modal>

    <!-- 获取验证码，并请求短信 -->
    <Modal v-model="verify_code_show" :width="350" :mask-closable="false"
           style="text-align: center;max-width: 100%;" footer-hide>
      <p slot="header">{{$t('page.reg.verify_code')}}</p>
      <Spin v-if="verify_code_loading" slot="close"></Spin>
      <div style="width: 100%;display:flex;margin-bottom: 5px;">
        <img :src="verify_code_data" width="100" height="32"
             style="vertical-align: middle; border: none;"
             @click.stop="onObtainCode"
             @load="verify_code_loading=false" alt=""/>
        <div style="padding: 0 3px;">
          <Input v-model="verify_code" ref="el_code"
                 maxlength="4"/>&nbsp;
          <p style="color:#ed4014">{{verify_code_result}}</p>
        </div>
        <Button @click.stop="doObtainSms" :disabled="verify_code_loading" type="primary">{{$t('common.btn_ok')}}</Button>
      </div>
    </Modal>

    <!-- 开通试用提示 -->
    <Modal v-model="alert_try" width="240"
           :mask-closable="false" :closable="false"
           class-name="alert-modal">
      <p slot="header">{{$t('common.alert_title')}}</p>
      <p slot="footer">
        <Button @click.stop="onRegTipOK"
                class="alert-btn">{{$t('page.reg.btn_continue')}}</Button>
        &nbsp;
        <Button @click.stop="$router.back()"
                class="alert-btn">{{$t('page.reg.btn_othertime')}}</Button>
      </p>
      <p>{{$t('page.reg.alert_reg')}}</p>
    </Modal>
  </div>
</template>
<script>
    import { SmsCode, VerifyCode } from '@/api/account';
    import SCodeSelect from '@/components/SCodeSelect';
    import MyJump from '@/components/MyJump';
    import common from '@/mixins/common';
    import Privacy from './DocPrivacy';

    export default {
        components: {
            MyJump,
            SCodeSelect,
            Privacy
        },
        mixins: [common],
        data () {
            const validatePass = (rule, value, callback) => {
                if (value === '') {
                    return callback(new Error(this.$t('page.login.ph_pwd')))
                } else if (!/^\w{6,15}$/.test(value)) {
                    return callback(new Error(this.$t('page.reg.ph_pwd')))
                } else if (this.formInfo.password1 !== '') {
                    this.$refs.formRegister.validateField('password1')
                }
                callback()
            }
            const validateCpasswd = (rule, value, callback) => {
                if (value !== this.formInfo.password) {
                    return callback(new Error(this.$t('page.reg.diff_pwd')))
                } else {
                    callback()
                }
            }
            return {
                jump: null,

                busy: false,
                logining: false,
                show_privacy: false,
                agree_privacy: false,
                alert_try: true,

                verify_code_show: false,
                verify_code_key: '',
                verify_code_data: null,
                verify_code_loading: true,
                verify_code: '',
                verify_code_result: '',

                smsInfo: '',
                smsDelay: 0,
                timer: null,
                type: true,

                formInfo: {
                    state_code: '',
                    mobile: '',
                    password: '',
                    password1: '',
                    code: ''
                },
                ruleValidate: {
                    state_code: [
                        { required: true, message: this.$t('page.login.ph_statecode'), trigger: 'change' }
                    ],
                    mobile: [
                        { required: true, message: this.$t('page.login.ph_mobile'), trigger: 'change' }
                    ],
                    password: [
                        { required: true, trigger: 'blur', validator: validatePass }
                    ],
                    password1: [
                        { required: true, trigger: 'blur', validator: validateCpasswd }
                    ],
                    code: [
                        { required: true, message: this.$t('page.reg.invalid_sms'), trigger: 'change' }
                    ]
                }
            }
        },
        methods: {
            onShowPwd (type) {
                this.type = !this.type
            },
            onRegTipOK () {
                this.alert_try = false;
                this.$refs.mobile.focus();
            },
            onObtainCode () {
                this.verify_code_loading = true;
                VerifyCode().then(
                    async res => {
                        this.verify_code_key = res.key;
                        this.verify_code_data = res.img;
                        this.$refs.el_code.focus();
                    }
                ).catch(() => {
                }).finally(() => {
                    this.verify_code_loading = false;
                });
            },
            doObtainSms () {
                if (this.verify_code.length !== 4) {
                    this.verify_code_result = this.$t('page.reg.invalid_code')
                    return false;
                }
                // this.verify_code_show = false;

                this.busy = true;
                this.smsDelay = 60;
                this.smsInfo = '(' + this.smsDelay + 's)';
                this.timer = setInterval(() => {
                    this.smsDelay--;
                    if (this.smsDelay > 0) {
                        this.smsInfo = '(' + this.smsDelay + 's)';
                    } else {
                        clearInterval(this.timer);
                        this.timer = null;
                        this.smsInfo = '';
                        this.smsDelay = 0;
                    }
                }, 1000);
                this.verify_code_result = ''
                SmsCode({
                    state_code: this.formInfo.state_code,
                    mobile: this.formInfo.mobile,
                    key: this.verify_code_key,
                    captcha: this.verify_code
                }).then(async res => {
                    this.$refs.el_sms.focus();
                    this.verify_code_show = false;
                }).catch((error) => {
                    this.verify_code_result = error.message
                    this.onObtainCode()
                    this.smsDelay = 0;
                }).finally(() => {
                    this.busy = false;
                });
            },
            onObtainSms () {
                if (this.busy) {
                    return;
                }
                let verify = true
                this.$refs.formRegister.validateField('mobile', (valid) => {
                    if (valid) {
                        verify = false
                    }
                })
                this.$refs.formRegister.validateField('state_code', (valid) => {
                    if (valid) {
                        verify = false
                    }
                })
                if (verify) {
                    this.verify_code_show = true;
                    this.verify_code_result = ''
                    this.verify_code = '';
                    this.onObtainCode();
                }
            },
            register () {
                if (this.busy) {
                    return;
                }

                this.$refs.formRegister.validate((valid) => {
                    if (valid) {
                        if (!this.agree_privacy) {
                            // this.$Message.error(this.$t('page.reg.tip_privacy'));
                            this.show_privacy = true;
                            return;
                        }
                        this.$store.commit('setLocalInfo', {
                            account: this.mobile,
                            code: this.state_code
                        });

                        this.busy = true;
                        this.logining = true;
                        this.$Spin.show();
                        const params = { ...this.formInfo }
                        params.stateCode = params.state_code
                        delete params.password1
                        delete params.state_code
                        this.$store.dispatch('register', params).then(() => {
                            // 跳转
                            this.jump = this.$route.params.target;
                        }).catch((error) => {
                            this.$Modal.error({
                                title: this.$t('page.reg.register_fail'),
                                content: error.message + ' <br/><br/>' + this.$t('common.err_server')
                            });
                        }).finally(() => {
                            this.$Spin.hide();
                            this.busy = false;
                            this.logining = false;
                        });
                    }
                })
            },
            toLogin () {
                this.$router.face.login();
            }
        },
        created () {
            // 地区码
            const info = this.$store.state.local_info;
            if (info) {
                this.formInfo.state_code = info.code;
            }
            if (this.$store.state.states) {
                this.states = this.$store.state.states;
            } else {
                this.$store.dispatch('loadStates')
                    .then((states) => {
                        this.states = states;
                    });
            }
        },
        mounted () {
            this.$refs.mobile.focus();
        }
    };
</script>

<style lang="scss">
  .page-register {
    padding: 1vw;
    width: 100%;
    max-width: 600px;
    text-align: center;
    margin: auto;

    .btn-eye{
      cursor: pointer;
      &:hover{
        opacity: 0.5;
      }
    }
  }
</style>
